import React from 'react';
import { CTAButton } from '../CTAButton';
const scattered = ['Courses', 'PDFs', 'Notes', 'Planning resources', 'Checklists', 'Patient records', 'Appointment information'];
export function About() {
  return <section className="w-full bg-navy-950 py-14 text-white md:py-20" aria-labelledby="about-title" data-id="element-41" data-mp="12plxh8dwv4iy">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-42" data-mp="yqmq7h4pivoc">
        <div className="grid gap-8 md:grid-cols-[0.85fr_1fr] md:items-start md:gap-12" data-id="element-43" data-mp="azhcb7ibudgo">
          <figure className="mx-auto w-full max-w-xs md:max-w-none" data-id="element-44" data-mp="60mo1q1lbwp6">
            <img src="https://cdn.magicpatterns.com/uploads/37KUGzGkiwPDP1ypfJuF1m/Dra._Karito_Odontologa_OF.png" alt="Dr. Karito, dentist and creator of Aligner Case Commander, in her dental clinic" className="w-full rounded-3xl object-cover ring-1 ring-white/10" width={943} height={1573} loading="lazy" data-id="element-45" data-mp="62h70ytaxeqm" />
          </figure>

          <div data-id="element-46" data-mp="3398eo47w9t0v">
            <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-brand-400" data-id="element-47" data-mp="339i8k2w28kbu">
              About Dr. Karito
            </p>
            <h2 id="about-title" className="mt-3 font-display text-[24px] font-black uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-48" data-mp="386idgah6bh1d">
              A practical system built for real aligner workflows
            </h2>

            <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-brand-100/85" data-id="element-49" data-mp="2kb5xgbll90dm">
              <p data-id="element-50" data-mp="2p8nup4q8tr5s">Dr. Karito created ALIGNER CASE COMMANDER™ around a simple observation:</p>
              <p className="font-semibold text-white" data-id="element-51" data-mp="2u80u0oyawqp9">
                Dentists working with aligners don’t necessarily lack information. They often have too much
                information spread across too many places.
              </p>
            </div>

            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-52" data-mp="9kfhipfulvuq">
              {scattered.map(item => <li key={item} className="rounded-full bg-white/[0.07] px-3 py-1.5 text-[12px] font-semibold text-brand-100/80 ring-1 ring-white/10" data-id="element-53" data-mp="ejio4ebh8a4t">
                  {item}
                </li>)}
            </ul>

            <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-brand-100/85" data-id="element-54" data-mp="2jkpabrrq8mto">
              <p data-id="element-55" data-mp="2fkykbqa0yaq7">
                And when all of that lives in different places, organizing a case can become unnecessarily
                complicated. That’s why Dr. Karito created ALIGNER CASE COMMANDER™.
              </p>
              <p data-id="element-56" data-mp="1msvhml84q082">
                Not as another lengthy course. Not as another theoretical ebook. But as a visual case
                organization system designed to help professionals structure the workflow surrounding their
                aligner cases.
              </p>
            </div>

            <p className="mt-7 font-display text-base font-black uppercase leading-snug text-brand-400 sm:text-xl" data-id="element-57" data-mp="183zaqrht6t91">
              Less scattered information. More case control. One visual workflow.
            </p>

            <div className="mt-7 max-w-md" data-id="element-58" data-mp="typaheq3ifh3">
              <CTAButton label="Get the system Dr. Karito built" tone="gold" onDark data-id="element-59" data-mp="ysbl71cp89a9" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}